import { Box, Flex } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import { ShimmerCss, StatusCss, IconButtonCss } from './styles'
import { AvatarShimmer } from './avatar'
import { TextShimmer } from './text'

export const FieldShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <AvatarShimmer
          // showToggle={true}
          showIcon={true}
          iconStyle="rounded"
          iconSize="md"
        />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...StatusCss }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...StatusCss }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...IconButtonCss, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
